
import React from 'react';

const AddressInfo = (user) => {
  const streetName = user.address ? user.address:"";
  const houseNumber = user.house_number ? user.house_number:"";
  const apartmentNumber = user.apartment_number ? `/${user.apartment_number}`:"";
  const city = user.city ? user.city:"";
  const postcode = user.postcode ? user.postcode:"";
  const country = user.country ? user.country:"";
  const address =`${streetName} ${houseNumber}${apartmentNumber} ${city} ${postcode} ${country}`;
  return(
    address
  )
}
export default AddressInfo



// WEBPACK FOOTER //
// ./src/components/InfoPerson/AddressInfo.js